import cn from 'classnames'
import { FC } from 'react'

import { DustedText } from '@shared'

import styles from '../Dialog.module.scss'

type Props = {
  text: string
}

export const DialogStoryteller: FC<Props> = ({ text }) => {
  return (
    <section className={cn(styles.dialogItem, styles.dialogItemStoryteller)}>
      <div className={styles.dialogItemStorytellerBorder} />
      <div className={styles.dialogItemStorytellerText}>
        <DustedText text={text} />
      </div>
    </section>
  )
}
